import { Box, CircularProgress } from '@mui/material';

export default function BenefitDetailsLoading() {
  return (
    <Box
      sx={{
        minHeight: 320,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress aria-label="Carregando benefício" />
    </Box>
  );
}
